export const MIN_BODY_PARAGRAPHS = 2;
export const MAX_BODY_PARAGRAPHS = 5;
export const DEFAULT_BODY_PARAGRAPHS = 3;

/**
 * Brings a typed body-paragraph count into the 2-5 range the outline builds for.
 * `adjusted` is true when the typed value was not already a whole number in range, so
 * the widget can tell the writer what it used instead.
 */
export function clampBodyCount(raw: number): {
  count: number;
  adjusted: boolean;
} {
  if (!Number.isFinite(raw)) {
    return { count: DEFAULT_BODY_PARAGRAPHS, adjusted: true };
  }
  const rounded = Math.round(raw);
  const count = Math.min(
    MAX_BODY_PARAGRAPHS,
    Math.max(MIN_BODY_PARAGRAPHS, rounded)
  );
  return { count, adjusted: count !== raw };
}
